import { ContractTypeEnum, IncomeFrequencyEnum } from '../../../../componentsNew/enums';
import api from '../../../../utils/api';

interface IncomeSourceEmploymentResponse {
    employer: string,
    contractType: string,
    startDate: string,
    endDate: string | null,
    grossIncome: number,
    incomeFrequency: IncomeFrequencyEnum;
    holidayAllowanceIncluded: boolean;
    thirteenthMonthPayIncluded: boolean;
    thirtyPercentFacilityApplicable: boolean;
    additionalIncome: number | null;
    additionalIncomeFrequency: IncomeFrequencyEnum | null;
    additionalIncomeComment: string | null;
}

const determineContractTypeSelect = (contractType: ContractTypeEnum | string) => {
    if (contractType === undefined) {
        return '';
    }

    if (
        contractType === ContractTypeEnum.FixedTerm
        || contractType === ContractTypeEnum.Indefinite
        || contractType === ContractTypeEnum.ZeroHour
    ) {
        return contractType;
    } else {
        return ContractTypeEnum.Other;
    }
}

export interface IncomeSourceEmploymentFormData {
    employer: string;
    contractTypeSelect: string;
    contractTypeTextArea: string;
    startDate: string;
    endDate: string,
    grossIncome: number;
    incomeFrequency: IncomeFrequencyEnum;
    holidayAllowanceIncluded: string;
    thirteenthMonthPayIncluded: string;
    thirtyPercentFacilityApplicable: string;
    hasExtraCompensation: string;
    additionalIncome: number;
    additionalIncomeFrequency: IncomeFrequencyEnum;
    additionalIncomeComment: string;
}

const incomeSourceEmploymentToFormData = (response: IncomeSourceEmploymentResponse): IncomeSourceEmploymentFormData => {
    const contractTypeSelect = determineContractTypeSelect(response.contractType);
    let contractTypeTextArea = '';

    if (contractTypeSelect === ContractTypeEnum.Other) {
        contractTypeTextArea = response.contractType;
    }

    return {
        employer: response.employer,
        contractTypeSelect,
        contractTypeTextArea,
        startDate: response.startDate,
        endDate: response.endDate || '',
        grossIncome: response.grossIncome,
        incomeFrequency: response.incomeFrequency,
        holidayAllowanceIncluded: response.holidayAllowanceIncluded.toString(),
        thirteenthMonthPayIncluded: response.thirteenthMonthPayIncluded.toString(),
        thirtyPercentFacilityApplicable: response.thirtyPercentFacilityApplicable.toString(),
        hasExtraCompensation: (!!response.additionalIncome).toString(),
        additionalIncome: response.additionalIncome,
        additionalIncomeFrequency: response.additionalIncomeFrequency,
        additionalIncomeComment: response.additionalIncomeComment,
    }
}

const findIncomeSourceEmployment = async (sourceId: string): Promise<IncomeSourceEmploymentFormData> => {
    const response: IncomeSourceEmploymentResponse = await api.getWithoutAuth(`api/screening/income-verification/details/employment`, { sourceId });

    return incomeSourceEmploymentToFormData(response);
}

export default findIncomeSourceEmployment;
